import ROUTES from "@app/common/routes";

export type UserSettingsSection =
  | "profile"
  | "integrations"
  | "assistant"
  | "recordingAndPlayback"
  | "reporting"
  | "smartScheduler"
  | "tagging"
  | "customVocabulary"
  | "email"
  | "other";

export interface UserSettingsRoute {
  route: string;
  sectionId: UserSettingsSection;
}

export const USER_SETTINGS_ROUTE_MIGRATIONS = [
  {
    oldPath: ROUTES.LEGACY.USER_SETTINGS_CALENDAR,
    newPath: ROUTES.USER_SETTINGS_INTEGRATIONS,
  },
  {
    oldPath: ROUTES.LEGACY.USER_SETTINGS_RECORDING_AND_PLAYBACK,
    newPath: ROUTES.USER_SETTINGS_RECORDING_AND_PLAYBACK,
  },
  {
    oldPath: ROUTES.LEGACY.USER_SETTINGS_SHARING,
    newPath: ROUTES.USER_SETTINGS_REPORTING,
  },
  {
    oldPath: ROUTES.LEGACY.USER_SETTINGS_CUSTOM_VOCABULARY,
    newPath: ROUTES.USER_SETTINGS_CUSTOM_VOCABULARY,
  },
  {
    oldPath: ROUTES.LEGACY.USER_SETTINGS_SMART_SCHEDULER,
    newPath: ROUTES.USER_SETTINGS_SMART_SCHEDULER,
  },
];

// if changing any of the routes below, make sure to add a migration to the route migrations above!!
export const USER_SETTINGS_ROUTES: UserSettingsRoute[] = [
  { route: ROUTES.USER_SETTINGS_PROFILE, sectionId: "profile" },
  { route: ROUTES.USER_SETTINGS_INTEGRATIONS, sectionId: "integrations" },
  { route: ROUTES.USER_SETTINGS_ASSISTANT, sectionId: "assistant" },
  {
    route: ROUTES.USER_SETTINGS_RECORDING_AND_PLAYBACK,
    sectionId: "recordingAndPlayback",
  },
  { route: ROUTES.USER_SETTINGS_REPORTING, sectionId: "reporting" },
  { route: ROUTES.USER_SETTINGS_SMART_SCHEDULER, sectionId: "smartScheduler" },
  { route: ROUTES.USER_SETTINGS_TAGGING, sectionId: "tagging" },
  {
    route: ROUTES.USER_SETTINGS_CUSTOM_VOCABULARY,
    sectionId: "customVocabulary",
  },
  { route: ROUTES.USER_SETTINGS_EMAIL, sectionId: "email" },
  { route: ROUTES.USER_SETTINGS_OTHER, sectionId: "other" },
];
